/**
 * Created by tofael on 10/24/17.
 */
import React from 'react';
import TextField from 'material-ui/TextField';

const styles = {
  container: {
    margin: '0px -8px 5px -8px'
  },
  formContainer: {
    width: '80%',
    margin: '40px 0px 0px 100px'
  },
  form: {
    height: '100%'
  },
  buttonGroup: {
    textAlign: 'center',
    marginTop: '20px',
    marginBottom: '20px'
  },
  button: {
    height: '45px',
    width: '200px'
  },
  buttonLabel: {
    lineHeight: '45px',
    fontSize: '16px',
    fontWeight: 'bold'
  },
  fields: {
    height: '50px',
    width: '80%',
    display: 'block'
  }
};

const PrescriptionForm = ({prescription, handlePrescriptionChange}) => {
  let {cc, rx, examinations, advice, investigations} = prescription;

  return (
    <div style={styles.form}>
      <TextField
        hintText="CC"
        floatingLabelText="cc"
        underlineShow={true}
        disabled={true}
        required={true}
        fullWidth={true}
        multiLine={true}
        rows={4}
        value={cc}/> <br/><br/>
      <TextField
        hintText="RX"
        underlineShow={true}
        required={true}
        fullWidth={true}
        multiLine={true}
        disabled={true}
        rows={4}
        value={rx}/> <br/><br/>
      <TextField
        hintText="Examinations"
        underlineShow={true}
        required={true}
        multiLine={true}
        fullWidth={true}
        disabled={true}
        rows={4}
        value={examinations}/>
      <TextField
        hintText="Advice"
        underlineShow={true}
        required={true}
        multiLine={true}
        disabled={true}
        fullWidth={true}
        rows={4}
        value={advice}/>
      <TextField
        hintText="Investigations"
        underlineShow={true}
        required={true}
        multiLine={true}
        fullWidth={true}
        disabled={true}
        rows={4}
        value={investigations}/>
    </div>
  )
};

export default PrescriptionForm;


// WEBPACK FOOTER //
// ./src/screens/mission-view/prescription-form.js